import { useEffect, useRef, useState } from "react";



import { styled } from '@mui/material/styles';
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, ListItemText, MenuItem, Paper, Select, SelectChangeEvent } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import SendIcon from '@mui/icons-material/Send';

import InputBase from '@mui/material/InputBase';
import PostInputBar from "./postInputBar";
import { setPostsRequest } from "../../../api/employeePortal";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { OfficeByCompany } from "../../../interfaces/s10Organization.interface";
import { getOfficesByCompanyCode, notifyUnapprovedPost } from "../../../api/s10OrganizationApi";
import { uploadFilesToFilestorage } from "../../../utils/media-files";
import { FileUploader } from "./FileUploader";
import MyDatepicker from "../../../components/my-datepicker";
import dayjs, { Dayjs } from "dayjs";
import { LoadingButton } from "@mui/lab";


const BootstrapInput = styled(InputBase)(({ theme }) => ({
    'label + &': {
      marginTop: theme.spacing(3),
    },
    '& .MuiInputBase-input': {
      borderRadius: "0.25rem",
      backgroundColor: "#fff",
      position: 'relative',
      border: `1px solid ${theme.s10palette.S10Greygrey50}`,
      fontSize: "0.875rem",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: "normal",
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      '&:focus': {
        // borderColor: '#80bdff',
        // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
}));


interface PostInputCardProps {
    setErrorMsg: (value: string) => void,
}


const ExpirationDate = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
}: any) => {

    return (
        <Grid container mb="1rem">
            <Grid item xs={6} pr=".5rem">
                <MyDatepicker
                    labelText="Desde"
                    value={startDate}
                    minDate={dayjs()}
                    setSelectedDate={(value) => {
                        setStartDate(dayjs(value).startOf('day'));
                        if (endDate) {
                            const dateDaysDiff = dayjs(value).diff(endDate, 'day');
                            console.log('dateDaysDiff', dateDaysDiff)
                            if (dateDaysDiff <= 0) {
                                setEndDate(dayjs(value).endOf('day'))
                            }
                        }
                    }}
                    
                />
            </Grid>
            <Grid item xs={6} pl='.5rem'>
                <MyDatepicker 
                    labelText="Hasta"
                    value={endDate}
                    minDate={startDate}
                    // maxDate={endMaxDate}
                    setSelectedDate={(value: Dayjs | null) => {
                        console.log("value", value)
                        console.log("dayjs(value).endOf('day')", dayjs(value).endOf('day'))
                        setEndDate(dayjs(value).endOf('day'))
                    }}
                />
            </Grid>
        </Grid>
    );
}

const PostInputCard = ({setErrorMsg}: PostInputCardProps) => {

    const myElementRef = useRef<HTMLButtonElement>(null);
    const {companyselected} = useSelector((state: RootState) => state.auth);
    const {savePostLoading} = useSelector((state: RootState) => state.posts);
    // const theme = useTheme();

    const [inputText, setInputtext] = useState("");
    const [allowComments, setAllowComments] = useState(true);
    const [authorizationLevel, setAuthorizationLevel] = useState<any[]>([0]);
    // const [uploadMediaOption, setUploadMediaOption] = useState<MediaOption | null>({
    //     label: "imagen, video o documentos pdf",
    //     // icon: UploadImageIcon,
    //     validExtensions: ["pdf", "jpg", "png", "gif", "jpeg", "mp4", "avi", "mov"],
    //     maxWeightMb: 10,
    // });
    const [offices, setOffices] = useState<OfficeByCompany[] | null>(null);
    const [gettingoffices, setGettingoffices] = useState<boolean>(false);
    const [fileImage, setFileImage] = useState<File>();
    const [fileDocument, setFileDocument] = useState<File>();
    const [filesError, setFilesError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [postSend, setPostSend] = useState(false);
    const [useExpiration, setUseExpiration] = useState(false);
    const [startDate, setStartDate] = useState<Dayjs>();
    const [endDate, setEndDate] = useState<Dayjs>();
    const [mentions, setMentions]= useState<any[]>([]);

    useEffect(() => {
        if (gettingoffices || offices || !companyselected) return;
        setGettingoffices(true);
        const getOffices = async () => {
            const result = await getOfficesByCompanyCode(companyselected?.Token, companyselected?.RUC);
            if (result?.status !== 200) {
                setOffices([]);
                setErrorMsg("Ocurrió un error al obtener las gerencias")
            } else {
                setOffices(result.data);
            }
            setGettingoffices(false);
        }
        getOffices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleChangeSelect = (event: SelectChangeEvent<{ value: number[] }>) => {
        let value = event.target.value as any as number[];
        if (value.includes(0)) {
           value = [0];
        }
        setAuthorizationLevel(value as any);
    };

    const handleSavePost = async () => {
        if (!companyselected?.Token || loading) {
            return;
        }
        setLoading(true)
        const mentions = handleCleanMentions();
        console.log(mentions)
        let mediaUrls: string[] = [];
        const files: File[] = [];
        if (fileImage) {
            files.push(fileImage);
        }
        if (fileDocument) {
            files.push(fileDocument);
        }
        if (files?.length) {
            const result = await uploadFilesToFilestorage(files, (error) => setErrorMsg(String(error)), true);
            if (!result || result.fileS3Urls.length === 0) {
                setLoading(false);
                return;
            }
            mediaUrls = result.fileS3Urls;
        }
        const finalAuthLevel = authorizationLevel.filter(l => l !== 0);
        const officeData = offices && finalAuthLevel?.length 
                            ? offices.filter(o => finalAuthLevel.includes(o.Id)) 
                            : null;
        const data = {
            postType: "post",
            // createdById: ,
            text: inputText,
            mediaUrls: files.length ? mediaUrls : undefined,
            authorizationLevel: officeData?.map(o => o.Id),
            allowComments,
            authorizationLevelName: officeData?.map(o => o.Name),
            ...(useExpiration && startDate && endDate
                ? {
                    availableSince: startDate.unix(),
                    availableUntil: endDate.unix()
                }
                : {}
            )
        };
        console.log(data)
        const result = await setPostsRequest(companyselected?.Token, data as any);
        if (result?.status === 200) {
            await notifyUnapprovedPost(inputText);
            setPostSend(true)
        } else {
            console.log(result)
            setErrorMsg(result?.data?.message || "Ocurrio un error al publicar tu mensaje, por favor reintenta")
        }
        setLoading(false)
    }

    const hadlerResetPostInput = () => {
        setInputtext("")
        setAuthorizationLevel([0]);
        setAllowComments(true);
        // setFiles([])
        setFileImage(undefined);
        setFileDocument(undefined);
        setFilesError(false)
        setErrorMsg("")
        setUseExpiration(false)
        setStartDate(undefined)
        setEndDate(undefined)
    }

    const handleCleanMentions = () => {
        const filteredSuggestions = mentions.filter(s => {
            const mention = `@[${s.Descripcion}](${s.CodIdentificador})`;
            return inputText.includes(mention); 
        });
        console.log(filteredSuggestions)
        setMentions(filteredSuggestions);
        return filteredSuggestions;
    } 

    return (<Paper 
        elevation={3}
        style={{
            width: "100%", 
            borderRadius: "0.5rem",
            padding: "1rem 1.5rem .5rem 1.5rem",
        }}
    >
        <Grid container width={"100%"} direction={"column"}>
            <PostInputBar 
                setInputtext={setInputtext} 
                inputText={inputText} 
                loading={loading}
                mentions={mentions}
                setMentions={setMentions}
            />
            <Divider style={{
                    width: "100%", 
                    marginTop: ".75rem", 
                    marginBottom: ".75rem",
                    color: "#E8E8E8",
                }}
            />
            
            <Grid container spacing="1rem" mb='.5rem'>
                <Grid item xs={6} justifyItems="end">
                    <FileUploader 
                        type="image" 
                        setFile={setFileImage}
                        file={fileImage}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FileUploader 
                        type="pdf" 
                        setFile={setFileDocument} 
                        file={fileDocument}
                    />
                </Grid>
            </Grid>
            <Grid container>
                <FormControlLabel
                    value="start"
                    control={<Checkbox
                        checked={allowComments}
                        onChange={() => setAllowComments(!allowComments)}
                        />}
                    label="Permitir comentarios"
                />
            </Grid>
            <Grid container>
                <FormControlLabel
                    value="start"
                    control={<Checkbox
                        checked={useExpiration}
                        onChange={() => setUseExpiration(!useExpiration)}
                        />}
                    label="Con vigencia?"                    
                />
            </Grid>
            {useExpiration && <ExpirationDate 
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
            />}
            <Grid container alignContent="space-between" direction="row" width="100%">
                <Grid item xs={6} pt=".5rem">
                <Select
                    multiple
                    id="demo-customized-select-native"
                    style={{ height: "2rem", width: "10rem", maxWidth: "100%" }}
                    value={authorizationLevel as any}
                    onChange={handleChangeSelect}
                    ref={myElementRef}
                    input={<BootstrapInput style={{ marginLeft: "-4rem" }} />}
                    renderValue={(selected) => (selected as any || []).length + " seleccionados"}
                    >
                    <MenuItem value={0}>
                        <Checkbox checked={authorizationLevel?.includes(0)} />
                        <ListItemText primary="Visible para todos" />
                    </MenuItem>
                    {offices?.map(o => (
                        <MenuItem key={o.Id} value={o.Id}>
                        <Checkbox checked={authorizationLevel?.includes(o.Id)} />
                        <ListItemText primary={o.Name} />
                        </MenuItem>
                    ))}
                    </Select>
                </Grid>
                <Grid item xs={6} pt=".2rem" alignItems="end" textAlign="end">
                    <LoadingButton 
                        loading={loading}
                        variant="contained"
                        style={{
                            marginLeft: "0.75rem",
                            // backgroundColor: theme.s10palette.S10Blueblue600,
                            fontSize: "0.875rem",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "normal",
                            padding: "0.62rem 1rem"
                        }}
                        startIcon={<SendIcon />}
                        disableElevation
                        onClick={handleSavePost}
                        disabled={!inputText || savePostLoading || filesError || loading || (useExpiration && (!startDate || !endDate))}
                    >
                        Publicar
                    </LoadingButton>
                </Grid>
            </Grid>
        </Grid>
        <Dialog
            open={postSend}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogTitle 
                id="responsive-dialog-title" 
                style={{padding: "0", margin: "2rem 0 1rem 0", textAlign: "center"}} 
                variant="h5"
            >
                Publicación enviada
            </DialogTitle>
            <DialogContent style={{width: "100%", height: "50%", padding: "0 1.5rem", textAlign: "center"}}>
                Se ha enviado exitosamente la publicación a la espera de la aprobación del administrador.
            </DialogContent>
            <DialogActions>
                <Grid container>
                <Grid item margin={"1.5rem 1.5rem 2.5rem 1.5rem"} padding={0} textAlign="center" xs={12}>
                    <Button 
                        variant="contained" 
                        style={{width: "8rem"}}
                        startIcon={<CheckIcon style={{height: "1rem"}} />}
                        onClick={() => {
                            setPostSend(false);
                            hadlerResetPostInput();
                        }}
                    >
                        Aceptar
                    </Button>
                </Grid>
                </Grid>
            </DialogActions>
        </Dialog>

    </Paper>)
}

export default PostInputCard;